"use strict";

function lawyerHeader() {
  if ($('.js-fix-header').length) {
    $(window).on('scroll', function (event) {
      $(window).scrollTop() > 20 ? $('.js-fix-header').addClass('smaller') : $('.js-fix-header').removeClass('smaller');
    });
  }
}

;